export const liege = {
    lat: 50.640652,
    lng: 5.57205,
    zoom: 8
};
